import FormattedMessage from 'I18n/components/FormattedMessage';
import { DownIcon, UpIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShowCompletedGroupsAccordion = ({
  onClick: handleClick,
  showCompletedGroups,
  numberOfCompletedChildGroups
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(HR, {
      color: "border-core-subtle"
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "task-view-card-show-hide-completed-link",
      onClick: handleClick,
      use: "link",
      children: showCompletedGroups ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: UpIcon
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.consolidatedUserGuide.taskViewCard.hideCompletedWithCount",
          options: {
            count: numberOfCompletedChildGroups
          }
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: DownIcon
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.consolidatedUserGuide.taskViewCard.showCompletedWithCount",
          options: {
            count: numberOfCompletedChildGroups
          }
        })]
      })
    })]
  });
};
export default ShowCompletedGroupsAccordion;